import { InfoSIM } from '../../../models/ConfigureLine';
import { getAllRestrictions } from '../../../services/ConfigureLineService';
import { checkBlockedLineRestriction, getBlockLineRestrictionId } from '../../../utils/dataTransformation/restrictions';
import { useConfigureLineContext } from '../../../context/configure-line-context/ConfigureLineContext';

const useConfigureLine = () => {
    const { setBlocked, setBlockedLineRestrictionId, eSimInstallFlow } = useConfigureLineContext();

    const checkRestrictions = async (productId: string, setIsBlocked?: (value: boolean) => void) => {
        if (!productId || productId.trim() === '') return;

        try {
            const response = await getAllRestrictions(productId);
            const isLineBlocked = checkBlockedLineRestriction(response.data);
            const restrictionId = getBlockLineRestrictionId(response.data) ?? '';
            setBlockedLineRestrictionId(restrictionId);
            setBlocked(isLineBlocked);
            setIsBlocked && setIsBlocked(isLineBlocked);
        } catch (error) {
            console.error(error);
        }
    };

    const getCorrectResourceId = (infoSim: InfoSIM, simType: string) => {
        if (eSimInstallFlow === 'qr') return infoSim.resourceId;
        else if (eSimInstallFlow === 'install') {
            if (infoSim.pending) return infoSim.resourceId;
            else
                return infoSim.multiSims?.find((multisim) => multisim.pending && multisim.type === simType)
                    ?.resourceId!;
        } else {
            return infoSim.resourceId;
        }
    };

    return { checkRestrictions, getCorrectResourceId };
};

export default useConfigureLine;
